module.exports = "/images/gutschein.png?1005cf4e66a8ff75e0febcfdf72b71b9";